import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import StoreX, { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import redux, { IState, ReduxMap } from '../../redux/redux';

interface IEvalAffiliate {
  LocationCode: string;
  ClientId: number;
}

interface IEvalCategory {
  Id: number;
  Name: string;
}

interface IEvalsData {
  Affiliates: IEvalAffiliate[];
  Categories: IEvalCategory[];
}

const AffiliateEvalPrinterPage = (props: IState) => {
  const [data, setData] = useState<IEvalsData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!props.User) return;
    setLoading(true);
    store.server
      .postApi<ServerResponse<IEvalsData>>('../AffiliateCoordinator/EvalsData', {})
      .then((x) => {
        if (x.Success) {
          setData(x.Value);
        } else {
          if (x.LoginRequired) redux.showLogin(true);
          toast.error(x.Message || 'Unable to load affiliate evals.', { autoClose: false });
        }
      })
      .finally(() => setLoading(false));
  }, [props.User]);

  if (loading || !data) {
    return (
      <div className="main-body-page grow" data-testid="affiliate-eval-printer-page">
        <h2>Affiliate Evals Finder</h2>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="main-body-page grow" data-testid="affiliate-eval-printer-page">
      <h2>Affiliate Evals Finder</h2>
      <div className="col-sm-12">
        {(data.Affiliates || []).length === 0 && (
          <div className="alert alert-info">No affiliates available for eval search.</div>
        )}
        {(data.Affiliates || []).map((affiliate) => (
          <div key={affiliate.ClientId} className="affiliate-group">
            <h4>{affiliate.LocationCode}</h4>
            <table className="table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th />
                  <th />
                </tr>
              </thead>
              <tbody>
                {(data.Categories || []).map((category) => (
                  <tr key={`${affiliate.ClientId}-${category.Id}`}>
                    <td>
                      &nbsp;&nbsp;&nbsp;
                      {category.Name}
                    </td>
                    <td>
                      <a
                        href={StoreX.BuildUrl(
                          `../JudgePortal/AffiliateEvals?finals=false&categoryId=${category.Id}&affiliateClientId=${affiliate.ClientId}`
                        )}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa fa-file-contract" /> Download Evals
                      </a>
                    </td>
                    <td>
                      <a
                        href={StoreX.BuildUrl(
                          `../JudgePortal/AffiliateEvals?finals=true&categoryId=${category.Id}&affiliateClientId=${affiliate.ClientId}`
                        )}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fad fa-file-contract" /> Download Finals Evals
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReduxMap(AffiliateEvalPrinterPage);
